import Vue from 'vue'
import App from './App.vue'
import router from './router'  //引入 vue-router
import store from './store'    //引入 vuex

// 全局配置
import '@/assets/scss/reset.scss' //全局样式
import 'element-ui/lib/theme-chalk/index.css' //element-ui样式
import http from '@/api/config'  //axios
import $ from 'jquery'
import './mock'   // mockjs
import 'lib-flexible'
import buttonlist from '@/components/buttonlist';//控制按钮
import Fragment from 'vue-fragment'
import XLSX from 'xlsx'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import productcode from '@/components/model/productcode'
import showproductcode from '@/components/model/showproductcode'
import VueLazyload from 'vue-lazyload'
import preventReClick from '@/components/plugins.js'

Vue.use(VueLazyload, {
    loading: require('@/assets/img/loading.png'),//加载中图片，一定要有，不然会一直重复加载占位图
    error: require('@/assets/img/loading.png')  //加载失败图片
});
Vue.use(VueQuillEditor)
Vue.use(XLSX)
Vue.use(Fragment.Plugin)
Vue.component('productcode',productcode)
Vue.component('showproductcode',showproductcode)
Vue.prototype.$http = http
Vue.prototype.getbrowser = function () {
    let userAgent = navigator.userAgent;
    let isChrome = userAgent.indexOf("chrome") != -1;
    let isSafari = userAgent.indexOf("safari") != -1;
    if (!isChrome && isSafari) {
        return false;
    } else {
        return true;
    }
}

// 第三方包
import ElementUI from 'element-ui'
Vue.use(ElementUI)
// Vue.use(ElementUI)

Vue.use(ElementUI, {
  size: 'medium',
});
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.component("buttonlist",buttonlist)
// loading
Vue.prototype.openLoading = function () {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '加载中...',                     // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.5)',       // 背景颜色
    target: '.sub-main',                    // 需要遮罩的区域
    body: true,
    customClass: 'mask'                     // 遮罩层新增类名
  })
  setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  }, 5000)
  return loading;
}

//帮助文档
Vue.prototype.hleptext ='输入查询器的【条件值】时，可以使用如下符号进行条件组合， 其中的双引号只是为了说明需要，实际输入时不需要输入。<br/>  1、">"     表示大于某个条件值' +
  '<br/>2、"<"     表示小于某个条件值<br/>3、">="    表示大于等于某个条件值<br/>4、"<="    表示小于等于某个条件值<br/>5、"!="    表示不等于某个条件值' +
  ' <br/>6、"%"     表示匹配任意值，如2%、%、3%ac等<br/> 7、".."    表示在某两个条件值之间并包括两端的条件值， 如2011-1-1..2011-1-31<br/>8、";"     表示合并条件也即或者的意思如1;2;3;4;5<br/>9、"!"     表示空也即没有，此符号独立使用<br/>10、"!(%[,%])"  表示去除多个%匹配的条件值 <br/>11、直接输入条件值表示等于';
Vue.config.productionTip = false
new Vue({
  router,
  store,
  $,
  render: h => h(App)
}).$mount('#app')